import Agendamentos from "@/modules/Agendamentos/pages/Index";
import AgendamentoForm from "@/modules/Agendamentos/pages/Form";
import AgendamentoAgenda from "@/modules/Agendamentos/pages/Agenda";

export default [
  {
    name: "agendamentos",
    path: "/agendamentos",
    component: Agendamentos,
    meta: { title: "Agendamentos" },
  },
  {
    name: "agendamentosNovo",
    path: "/agendamentos/novo",
    component: AgendamentoForm,
    meta: { title: "Agendamentos - Novo" },
  },
  {
    name: "agendamentosAgenda",
    path: "/agendamentos/agenda",
    component: AgendamentoAgenda,
    meta: { title: "Agendamentos - Agenda" },
  },
  {
    name: "agendamentosEditar",
    path: "/agendamentos/:id/editar",
    component: AgendamentoForm,
    meta: { title: "Agendamentos - Editar" },
  },
];
